import { matchPath } from "react-router";

/**
 * Route patterns as registered in AppRouter, so pageviews report `/emulators/:id`
 * instead of raw ids. Order matters: first match wins, so static segments come
 * before params. A test fails if AppRouter gains a path missing here.
 */
export const ROUTE_PATTERNS = [
  "/",
  "/login",
  "/onboarding/init",
  "/emulator-popout",
  "/link/gitlab",
  "/account/vcs-link-redirect",
  "/emulators",
  "/emulators/:id",
  "/workspaces",
  "/builds",
  "/org",
  "/org/tools/:tool",
  "/org/:tab",
  "/cli",
  "/account",
  "/account/cli",
  "/account/:tab",
  "/platform",
  "/platform/tenants",
  "/platform/tenants/new",
  "/platform/tenants/:id",
  "/platform/:tab",
  // legacy redirects
  "/install",
  "/dev/emulators/:id?",
  "/dashboards/snapshots",
  "/account/:tenantId/:section",
  "/admin",
  "/admin/onboard",
  "/admin/tenants/:id?",
  "/admin/*",
];

/** Return the matching route pattern, or a generic fallback for unknown paths. */
export function routePattern(pathname: string): string {
  for (const pattern of ROUTE_PATTERNS) {
    if (matchPath({ path: pattern, end: true }, pathname)) return pattern;
  }
  return "unknown";
}
